export { default } from './FormAttribute.vue'
